module.exports = __webpack_public_path__ + "img/82.1a833d96.png";